import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function ArrowBottomMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path d="M13 17.172l5.364-5.364 1.414 1.414L12 21l-7.778-7.778 1.414-1.414L11 17.172V3h2v14.172z"  /></Svg>;
}
export default ArrowBottomMedium;